import { useEffect } from 'react';
import { useDeploymentInfo } from '../config/useDeploymentInfo';
import { DEPLOYMENT_ENVIRONMENTS } from '../common/constants/ppConstants';
import { getLogger } from '../logging/logger.ts';

const log = getLogger('tealium-script');

export function TealiumScript({ enableTealium, isBot }: Readonly<{ enableTealium: boolean; isBot: boolean }>) {
  const { DEPLOYMENT_ENVIRONMENT } = useDeploymentInfo();

  let tealiumEnv = '';
  if (DEPLOYMENT_ENVIRONMENT === DEPLOYMENT_ENVIRONMENTS.PROD) {
    tealiumEnv = 'prod';
  } else if (DEPLOYMENT_ENVIRONMENT === DEPLOYMENT_ENVIRONMENTS.PREVIEW) {
    tealiumEnv = 'qa';
  } else if ('TEST' === DEPLOYMENT_ENVIRONMENT || 'STAGE' === DEPLOYMENT_ENVIRONMENT) {
    tealiumEnv = 'dev';
  }

  useEffect(() => {
    if (!(enableTealium && tealiumEnv) || isBot) {
      log.info(
        `Tealium is disabled - enableTealium: ${enableTealium}, deployment environment: ${DEPLOYMENT_ENVIRONMENT}, isBot: ${isBot}`
      );
    }
  }, [enableTealium, tealiumEnv, DEPLOYMENT_ENVIRONMENT, isBot]);

  if (enableTealium && tealiumEnv) {
    return <TealiumScriptTag tealiumEnv={tealiumEnv} />;
  } else {
    // tealium not enabled or local development or error in env config
    return null;
  }
}

function TealiumScriptTag({ tealiumEnv }: Readonly<{ tealiumEnv: string }>) {
  useEffect(() => {
    // Der Effect läuft nur im Client, das Script Tag wird aber inital auch auf dem Server gerendert.
    log.info(`Configured Tealium for ${tealiumEnv} ...`);
  }, [tealiumEnv]);

  const tealiumSrc = `https://tags.tiqcdn.com/utag/coop-ch/tgch-transgourmet/${tealiumEnv}/utag.js`;
  return <script src={tealiumSrc}></script>;
}
